module.exports = __webpack_public_path__ + "static/016-f2a59bb2267b5ad7609073edaa1e572b.jpg";